// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"c850def7","363":"30946562","459":"05b63636","737":"007db901"}[chunkId] + ".css";
};